<template>
  <!---->
  <div class="div-class">
    <ShortCut></ShortCut>
    <LogoHome></LogoHome>
    <Navigation></Navigation>
    <div class="main">
      <LeftMenu class="left-menu"></LeftMenu>
      <div class="right-menu">
        <div class="right-title-class">
          <HeaderTag></HeaderTag>
        </div>
        <el-form :inline="true" :model="formInline" class="form-inline">
          <div class="form-item-class">
            <div class="item-class">
              <el-form-item label="起始日期">
                <el-date-picker
                  v-model="formInline.startDate"
                  type="date"
                  placeholder="选择起始日期">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="item-class">
              <el-form-item label="终止日期" >
                <el-date-picker
                  v-model="formInline.endDate"
                  type="date"
                  placeholder="选择终止日期">
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="item-class">
              <el-form-item label="单据编号" >
                <el-input v-model="formInline.billCode" placeholder="请输入单号" style="width: 220px"></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="form-item-class">
            <div class="item-class">
              <el-form-item label="单位名称">
                <el-input v-model="formInline.businessName" placeholder="请输入客户名称" style="width: 220px"></el-input>
              </el-form-item>
            </div>
            <div class="item-class">
              <el-form-item label="商品名称">
                <el-input v-model="formInline.goodsName" placeholder="请输入商品名称" style="width: 220px"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button @click="onRest">重置</el-button>
              <el-button @click="exportTable">导出</el-button>
            </div>
          </div>
        </el-form>
        <el-table
          ref="multipleTable"
          :data="queryDatas"
          tooltip-effect="dark"
          style="width: 100%"
          height="520"
          id="out-table"
        >
          <el-table-column
            prop="BILLNO"
            width="80" v-if="false">
          </el-table-column>
          <el-table-column
            label="单据编号"
            width="130"
          >
            <template slot-scope="scope">{{ scope.row.BILLCODE }}</template>
          </el-table-column>
          <el-table-column
            prop="DATES"
            label="日期"
            width="110"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="BUSINESSNAME"
            label="单位名称"
            width="250"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="GOODSNAME"
            label="商品名称"
            width="250"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="GOODSSPEC"
            label="商品规格"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="MANUFACTURER"
            label="生产厂家"
            width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="NUM"
            label="数量"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="TAXPRICE"
            label="单价"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="TAXAMOUNT"
            label="金额"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="BATCHCODE"
            label="批号"
            width="120"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="VALDATE"
            label="有效期"
            width="120"
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column
            prop="INVOICENUM"
            label="已开发票数量"
            width="120"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="INVOICEAMT"
            label="已开发票金额"
            width="120"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="REMARK"
            label="备注"
            width="120"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
import ShortCut from '../component/ShortCut'
import Navigation from "../component/Navigation";
import LogoHome from "../component/LogoHome";
import LeftMenu from "../component/LeftMenu";
import HeaderTag from "../component/HeaderTag";
import {billOrders, getBillNo,saveBill} from '../../api';
export default {
  components:{
    ShortCut,
    Navigation,
    LogoHome,
    LeftMenu,
    HeaderTag
  },
  data(){
    return{
      queryDatas:[],
      userInfo:{},
      totalNum:0,
      totalAmount:0,
      childDatas:[],
      BillNo:0,
      BILLCODE:"",
      formInline:{
        startDate:"",
        endDate:"",
        billCode:"",
        businessName:"",
        goodsName:""
      }
    }
  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    queryBill(){
      this.queryDatas = [];
      billOrders({
        M_STAFFID: this.userInfo.STAFFID,
        M_ORGID: this.userInfo.OWNERID,
        M_ENTID: this.userInfo.ENTID,
        M_STARTDATE: this.formInline.startDate,
        M_ENDDATE: this.formInline.endDate,
        M_ACTION: 90,
        M_PAGECOUNT: 1000,
        M_PAGE: 1,
        M_BILLCODE: this.formInline.billCode,
        M_CON: this.formInline.businessName,
        M_COALL: this.formInline.goodsName,


      }).then(res => {
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        console.log("dataset" + dataset);
        if (dataset.length == 0) {
          // this.$message.error('当前未存在合单单据');
          return false;
        } else {
          //this.options=dataset;
          this.queryDatas = dataset;
          // console.log(dataset[0]);
          // sessionStorage.setItem("USERINFO",dataset[0]);
          // this.$router.push('/home');
        }
      }).catch(err => {
        // 请求失败执行
        // console.log(err)
      })

    },

    initForm(){
      this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));
    },
    onSubmit(){
      this.queryBill();
    },
    onRest(){
      let dates = new Date();
      let year = dates.getFullYear();
      let month = Math.round(dates.getMonth())+1<10 ? "0"+ (Math.round(dates.getMonth())+1) : Math.round(dates.getMonth())+1;
      let date = dates.getDate()<10 ? "0"+ dates.getDate() : dates.getDate();
      this.formInline.startDate=year+"-"+month+"-"+date;
      this.formInline.endDate=year+"-"+month+"-"+date;
      this.formInline.billCode="";
      this.formInline.busineeName = "";
      this.formInline.goodsName=""
    },
    //定义导出Excel表格事件
    exportTable () {
      let table = document.getElementById("out-table")
      if (!table) return
      // 复制一份table的dom
      let div = document.createElement('div');
      div.innerHTML = table.innerHTML
      // 移除掉左右的fixed
      let fixedLeft = div.querySelector('.el-table__fixed')
      if (fixedLeft) fixedLeft.remove()
      let fixedRight = div.querySelector('.el-table__fixed-right')
      if (fixedRight) fixedRight.remove()
      // 导出处理好的数据
      let book = this.$XLSX.utils.table_to_book(div)
      let write = this.$XLSX.write(book, {bookType: 'xlsx', bookSST: true, type: 'array'})
      try {
        this.$FileSaver.saveAs(new Blob([write], { type: 'application/octet-stream' }), '销售明细.xlsx');
      } catch (e) {
        console.log('导出失败', e)
      }
    }
  },
  mounted(){
    this.initForm();
    this.onRest();
    // this.queryBill();
    let tag = [];
    if(sessionStorage.getItem("TAG") ==null || sessionStorage.getItem("TAG")==""){

    }else{
      tag=JSON.parse(sessionStorage.getItem("TAG"));
    }
    let tagChild = {};
    tagChild.type = "";
    tagChild.name = "销售明细查询";
    tagChild.url = "/saleFlowQuery"
    let tagFlag = false;
    for(var j=0;j<tag.length;j++){
      if(JSON.stringify(tag[j])==JSON.stringify(tagChild)){
        tagFlag = true;
      }
    }
    if(!tagFlag){
      tag.push(tagChild);
    }
    sessionStorage.setItem("TAG",JSON.stringify(tag));
  }
}
</script>

<style scoped>
.nav_item{
  height:45px;
  line-height:45px;
  color:white;
  list-style-type:none
}
.main{
  height: 100%;
  display: flex;
}
.div-class{
  height: 100%;
  width: 100%;
  position:fixed;
}

.right-menu{
  padding-left: 5px;
  width: 70%;
}

.right-title-class{
  height: 45px;
  text-align: left;
  line-height: 45px;
  background-color: #f1f1f1;
  padding-left: 10px;
  font-size: 20px;
}

#footer{
  width: 70%;
  height: 50px;
  position: fixed;
  bottom: 0;
  /*padding-left: 10px;*/
  background: #E5E5E5;
  z-index: 9999;
}
#footer div{
  display: inline-block;
}
#footer>.foot_select{
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding-left: 5px;
  cursor: pointer;
  font-size: 14px;
}
.foot_select input,.foot_select label{
  cursor: pointer;
}
.foot_op{
  float: left;
  line-height: 50px;
  height: 50px;
}
.foot_op>.foot_remove{
  margin-left: 0px;
  font-size: 14px;
  cursor: pointer;
}
.foot_remove:hover{
  color: #f40;
}
.foot_total{
  float: right;
}
.foot_total>.amout-sum{
  cursor: pointer;
  height: 50px;
  color: #3c3c3c;
}
.foot_total .txt{
  line-height: 50px;
  font-size: 14px;
}
.btn-area>.btn-sumbit{
  display: inline-block;
  background: #B0B0B0;
  color: #fff;
  border-left: 1px solid #e7e7e7;
  width: 119px;
  height: 50px;
  cursor: not-allowed;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}
.btn-area>.btn-sumbit.btn-allow{
  background: #f22d00;
  cursor: pointer;
}
.left-btn{
  background: #387af6;
  cursor: pointer;
  display: inline-block;
  color: #fff;
  border-left: 1px solid #e7e7e7;
  width: 119px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}

.amout-sum>#selected_amout{
  padding: 0 5px;
  color: #f40;
  font-weight: 700;
  font-size: 18px;
}

.form-inline{
  padding-top: 10px;
}

.item-class{
  float: left;
}

.form-item-class{
  display: flex;
  float: left;
  padding-left: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/SaleFlowQuery.vue